import { lightTheme } from "@/customTheme";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.415 7.59582L16.2434 10.4242"
      stroke={props.disabled ? lightTheme.colors.icon.disable : props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2}
      strokeLinecap="square"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8895 4.41421C16.6705 3.63316 17.9369 3.63317 18.7179 4.41421L20.1321 5.82843C20.9132 6.60948 20.9132 7.87581 20.1321 8.65685L9.52554 19.2635L4.57579 19.9706L5.2829 15.0208L15.8895 4.41421Z"
      stroke={props.disabled ? lightTheme.colors.icon.disable : props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;
